import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import * as homeInitialState from '../initialState';
import { AbsolutePositioned } from '../../../components/Layout/AbsolutePositioned';
import { ContentContainer } from '../../../components/Layout/ContentContainer';
import { Screen, SplitScreen } from '../../../components/Layout/Screen';
import Counter from '../../../components/Counter';
import LineLink from '../../../components/LineLink';

// Assets
import { brandColors, device } from '../../../styles/variables';
import background from '../../../assets/images/brand_botanical.png';

const StyledScreen = Screen.extend`
  position: relative;
  overflow: hidden;
`;

const StyledSplitScreen = SplitScreen.extend`
  height: 50%;
  vertical-align: top;
`;

const BackgroundPosition = AbsolutePositioned.extend`
  background: url(${background});
  background-size: 120%;
  background-position: center;
  opacity: 0.4;
`;

const CounterContainer = styled.div`
  max-width: 470px;
  margin: 138px 0 0 0;
  width: 100%;
  @media ${device.laptop} {
    margin: 52px 0 0 0;
  }
`;

const LineLinkContainer = styled.div`
  margin: 138px 0 0 40px;
  @media ${device.laptop} {
    margin: 88px 0 0 169px;
  }
`;

class CounterScreen extends React.PureComponent {
  constructor(props) {
    super(props);

    // need to set the store for home
    // place to set all the required elements
    // but for now it is just stored in the initialState.js file
    this.homeDetails = homeInitialState.default;
  }

  render() {
    return (
      <StyledScreen className="counter-screen">
        <AbsolutePositioned bottom="0" right="0">
          <StyledSplitScreen background={brandColors.blue} />
          <StyledSplitScreen background={brandColors.yellow} />
          <StyledSplitScreen background={brandColors.orange} />
          <StyledSplitScreen background={brandColors.blue} />
        </AbsolutePositioned>
        <BackgroundPosition bottom="0" right="0" />
        <AbsolutePositioned bottom="0" right="0">
          <ContentContainer>
            <StyledSplitScreen>
              <CounterContainer>
                <Counter maxCount={1220} title="projects" />
              </CounterContainer>
            </StyledSplitScreen>
            <StyledSplitScreen>
              <CounterContainer>
                <Counter maxCount={68} title="clients" color={brandColors.purple} />
              </CounterContainer>
            </StyledSplitScreen>
            <StyledSplitScreen>
              <CounterContainer>
                <Counter maxCount={33} title="years of experience" />
              </CounterContainer>
            </StyledSplitScreen>
            <StyledSplitScreen>
              <LineLinkContainer>
                <LineLink
                  className=""
                  linkText="how do we do it?"
                  subtitle="see our services"
                  linkColor={brandColors.orange}
                  route="/services"
                  lineTextWidth="220px"
                  lineAnimate
                  active
                />
              </LineLinkContainer>
            </StyledSplitScreen>
          </ContentContainer>
        </AbsolutePositioned>
      </StyledScreen>
    );
  }
}

export default connect()(CounterScreen);



// WEBPACK FOOTER //
// ./src/pages/Home/screens/Counter.jsx